module.exports = __webpack_public_path__ + "static/media/SNX.38503398.svg";